<template>
  <div id="successMessage">
	<svg width="150" height="142" viewBox="0 0 150 142" fill="none" xmlns="http://www.w3.org/2000/svg">
	  <path d="M125 35.5L56.25 100.583L25 71" stroke="#24FF00" stroke-width="10" stroke-linecap="round" stroke-linejoin="round"/>
	</svg>

    <div class="sector bg-darker wa">
      <div class="fs30">Успех</div>
	  <div class="sub">Мы зачислим <span class="t-red">R$</span> как можно скорее</div>

	  <div class="fs30 spacetop">Внимание!</div>
	  <div class="fs30">Сохраните номер заказа: {{ data.id }}</div>
	  <div class="sub">В случае помощи нам необходим будет этот номер!</div>
	</div>

	<button class="fs24">Хорошо</button>
  </div>
</template>

<script>
export default {
  props: ["data"],
}
</script>
